import React from "react";

const AppointmentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
    >
      <ellipse
        cx="15"
        cy="15"
        rx="15"
        ry="15"
        transform="rotate(90 15 15)"
        fill="white"
      />
      <ellipse
        cx="9.98465"
        cy="9.83225"
        rx="8.88889"
        ry="8.88889"
        transform="rotate(90 9.98465 9.83225)"
        fill="#348939"
        fill-opacity="0.08"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1294 10.9909C12.2179 11.0794 12.2676 11.1994 12.2676 11.3245C12.2676 11.4496 12.2179 11.5696 12.1294 11.6581L10.2421 13.5454C10.1536 13.6339 10.0336 13.6836 9.90848 13.6836C9.78337 13.6836 9.66338 13.6339 9.57489 13.5454L7.68754 11.6581C7.60159 11.5691 7.55403 11.4499 7.5551 11.3262C7.55618 11.2025 7.6058 11.0841 7.69329 10.9967C7.78077 10.9092 7.89911 10.8596 8.02283 10.8585C8.14654 10.8574 8.26573 10.905 8.35472 10.9909L9.43664 12.0728L9.43665 6.60611C9.43665 6.48097 9.48636 6.36095 9.57484 6.27247C9.66333 6.18398 9.78334 6.13427 9.90848 6.13427C10.0336 6.13427 10.1536 6.18398 10.2421 6.27247C10.3306 6.36095 10.3803 6.48097 10.3803 6.60611L10.3803 12.0728L11.4622 10.9909C11.5507 10.9025 11.6707 10.8528 11.7958 10.8528C11.921 10.8528 12.0409 10.9025 12.1294 10.9909Z"
        fill="#16a34a"
        //fill-opacity=""
      />
    </svg>
  );
};

export default AppointmentIcon;
